import React from 'react'
import PropTypes from 'prop-types'
import {Motion, spring} from 'react-motion'
import styled from 'styled-components'
import { AngleDoubleLeft } from 'styled-icons/fa-solid/AngleDoubleLeft'
import { AngleDoubleRight } from 'styled-icons/fa-solid/AngleDoubleRight'
import { AngleDoubleDown } from 'styled-icons/fa-solid/AngleDoubleDown'
import { AngleDoubleUp } from 'styled-icons/fa-solid/AngleDoubleUp'

const RightOpen = styled(AngleDoubleLeft)`color: white;`
const RightClose = styled(AngleDoubleRight)`color: white;`
const BottomOpen = styled(AngleDoubleUp)`color: white;`
const BottomClose = styled(AngleDoubleDown)`color: white;`

const Container = styled.div`
  display: block;
  position: fixed;
  overflow: hidden;
  z-index: 10001;
  height: ${props => props.right ? '100%' : props.size + 20 + 'px'};
  ${props => props.right ?
    'right: 0; top: 120px;' :
    'left: 0; bottom: 0; width: 100%;'
  }
`
const Control = styled.span`
  display: block;
  position: relative;
  width: 28px;
  line-height: 20px;
  text-align: center;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  ${props => props.right ? 'float: left;' : 'margin: auto;'}
  border-radius: ${props => props.right ? '3px 0 0 3px' : '3px 3px 0 0'};
`
const Content = styled.div`
  display: block;
  position: relative;
  overflow: auto;
  background-color: ${props => props.background};
  padding: ${props => props.padding}px;
  width: ${props => props.right ? props.size + 'px' : '100%'};
  height: ${props => props.right ? '100%' : props.size + 'px'};
  box-shadow: ${props => props.right ?
    'rgba(0, 0, 0, 0.2) 0px 10px 20px, rgba(0, 0, 0, 0.2) 0px 6px 6px' :
    'rgba(0, 0, 0, 0.2) 0px -10px 20px -6px, rgba(0, 0, 0, 0.2) 0px -6px 6px -6px'
  };
`

class Drawer extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      open: this.props.open
    }
  }

  onClick = () => this.setState({ open: !this.state.open })
  componentWillReceiveProps = props => this.state.open !== props.open && this.setState({ open:props.open })

  render() {
    const { open } = this.state
    const { size, placement } = this.props
    const isRight = placement === 'right'

    return (
      <Motion style={{n: spring(open ? 0 : size)}}>
        { ({n}) =>
          <Container right={isRight} size={size} style={{transform: isRight ? `translate3d(${n}px, 0, 0)` : `translate3d(0, ${n}px, 0)` }}>
            <Control onClick={this.onClick} right={isRight}>
              {
                isRight ?
                (open ? <RightClose size={12}/> : <RightOpen size={12}/>) :
                (open ? <BottomClose size={12}/> : <BottomOpen size={12}/>)
              }
            </Control>
            <Content right={isRight} {...this.props}>
              { this.props.children }
            </Content>
          </Container>
        }
      </Motion>
    )
  }
}

Drawer.defaultProps = {
  size: 200,
  placement: 'right',
  open: false,
  padding: 10,
  background: 'rgba(255, 255, 255, 0.8)',
}

Drawer.propTypes = {
  size: PropTypes.number,
  placement: PropTypes.string,
  open: PropTypes.bool,
  padding: PropTypes.number,
  background: PropTypes.string,
}

export default Drawer



// WEBPACK FOOTER //
// ./src/components/widgets/Drawer.js